import clsx from "clsx";
import { memo, useState } from "react";

import classes from "../../styles.module.scss";
import type { IFilterSelectProps } from "../../types";
import {
  addAllItemsToFilter,
  handleClickFilterOption,
  isAllItemSelected,
  isItemSelected,
} from "../../helper";

import { Typography } from "@components/atoms/typography";
import { Icon } from "@components/atoms/icons";
import { Checkbox } from "@components/atoms/checkbox";

export const FilterSelect = memo(function FilterSelect(
  props: IFilterSelectProps,
) {
  // TODO ADD OPEN ANIMATION

  const { index, content, options: allOptions, value, onFilterSelect } = props;
  const { title, options } = content;

  const [open, setOpen] = useState(false);

  return (
    <div className={clsx(classes.filter__filterItem)}>
      <div
        className={clsx(classes.filter__item, classes.filter__filterItemHead)}
        onClick={() => {
          setOpen((prevState) => !prevState);
        }}
      >
        <Typography variant={"caption1"} color={"primary-text"}>
          {title}
        </Typography>
        <Icon
          name={"AltArrowDown"}
          type={"linear"}
          color={"primary-text"}
          className={clsx(
            classes.filter__icon,
            open && classes.filter__iconOpen,
          )}
        />
      </div>
      {open && (
        <div className={clsx(classes.filter__filterItemsContainer)}>
          {options?.length > 1 && (
            <div
              key={`$ALL_FILTER_${index}`}
              className={clsx(classes.filter__fiterItemContent)}
            >
              <Checkbox
                title={"همه"}
                value={isAllItemSelected(index, value, allOptions)}
                onChange={() => {
                  addAllItemsToFilter(index, allOptions, value, onFilterSelect);
                }}
              />
            </div>
          )}
          {options?.map((option) => {
            const isSelected = isItemSelected(index, option?.key, value);

            return (
              <div
                key={option?.key}
                className={clsx(classes.filter__fiterItemContent)}
              >
                <Checkbox
                  title={option?.value}
                  value={isSelected}
                  onChange={() => {
                    handleClickFilterOption(
                      index,
                      option,
                      value,
                      !isSelected,
                      onFilterSelect,
                    );
                  }}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
});
